import { Edit2, Trash2 } from "lucide-react";

export function MealDisplayBack({ recipe, toggleFlip, deleteMeal, editMeal }) {
  const handleEdit = (recipeId) => {
    toggleFlip(false);
    editMeal(recipeId);
  };

  const handleDelete = async (recipeId) => {
    toggleFlip(false);
    await deleteMeal(recipeId);
  };

  return (
    <div
      className="absolute w-full h-full bg-white rounded-lg border border-gray-200 overflow-hidden shadow-lg"
      style={{
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        transform: "rotateY(180deg)",
      }}
    >
      <div className="h-full flex flex-col p-5">
        <h3 className="font-medium text-gray-900 mb-3 text-lg">
          {recipe.name}
        </h3>

        <div className="flex-1 overflow-y-auto mb-4">
          <h4 className="text-sm font-medium text-black-700 mb-2">
            Ingredients:
          </h4>
          <ul className="space-y-1.5">
            {recipe.ingredientList ? (
              recipe.ingredientList.map((ingredient, idx) => (
                <li
                  key={idx}
                  className="text-sm text-gray-600 flex items-start"
                >
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-gray-400 mt-1.5 mr-2 flex-shrink-0"></span>
                  <span>
                    {ingredient.ingredientQuantity} {ingredient.ingredientUnit}{" "}
                    {ingredient.ingredientName}
                  </span>
                </li>
              ))
            ) : (
              <div>Add some ingredients</div>
            )}
          </ul>
        </div>

        <div className="flex gap-2 pt-3 border-t border-gray-200">
          <button
            onClick={(e) => handleEdit(recipe.mealId)}
            className="flex-1 px-3 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
          >
            <Edit2 className="w-4 h-4" />
            Edit
          </button>
          <button
            onClick={(e) => handleDelete(recipe.mealId)}
            className="flex-1 px-3 py-2 bg-red-50 text-red-600 rounded-lg text-sm font-medium hover:bg-red-100 transition-colors flex items-center justify-center gap-2"
          >
            <Trash2 className="w-4 h-4" />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
